module.exports = __webpack_public_path__ + "img/planner.9f6a3048.png";